import $ from 'jquery';

import Section from "../Section";
import MobileMenu from '../global/MobileMenu';
import Localization from '../global/Localization';

export default class Header extends Section {
    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        this.$element = $(element)

        this.loadStickyHeader();
        this.loadSearch();
        this.mobileMenu = new MobileMenu(theme, document.querySelector('.mobile-menu--wrapper'));
        this.loadDropdownHover();
        this.fixHeaderHeight();

        this.localization = new Localization(theme, element);
        this.theme.loadIcons();
    }

    onSectionSelect = ({ element, sectionId, load }) => {
        this.theme.loadDrawers();
    }

    onBlockSelect = ({ element }) => {
        // Enable hover to use proper menu colors
        this.element.classList.add('touch-hover');

        // Open megamenu which is being edited (both normal menu and sticky menu)
        if (element.dataset.megaMenuBlockId) {
            // Open normal header (not sticky one) as Shopify will scroll to it automatically
            const $element = $(`.header-menu-wrapper [data-mega-menu-block-id="${element.dataset.megaMenuBlockId}"]`);
            const $menu = $element.closest('li.dropdown > .mega-menu--dropdown-wrapper');
            const $handler = $menu.find('.dropdown-envy-toggle');
            this.openMenu($menu, $handler, true);
        }
    }

    onBlockDeselect = () => {
        // Disable hover
        this.element.classList.remove('touch-hover');

        // Close opened megamenus
        $('.mega-menu--dropdown-wrapper.force-open').removeClass('force-open');
    }

    loadSearch = () => {
        this.$element.find(".search-show").off('click').on('click', function() {
            var $this = $(this);
            if ($this.closest('.sticky-header-wrapper').length > 0) {
                var $search = $('.sticky-header-search');
                $search.toggleClass('expanded');
                $search.find('#search_text').focus();
            } else {
                $("#top-search-wrapper").toggleClass('expanded');
                $("#top-search-wrapper #search_text").focus();
            }
            return false;
        });

        if ($(window).width() < 767) {
            $('.mobile-menu-close').trigger('click');
        }
    }

    updateStickyHeader = () => {
        // How many pixel below the menu should the sticky menu appear
        const menu_breakpoint_offset = 50;

        // breakpoint is where the sticky menu should appear = menu bottom + 50px
        const menu_breakpoint = this.element.clientTop + this.element.clientHeight + menu_breakpoint_offset;

        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const is_sticky = scrollTop > menu_breakpoint;
        this.$sticky.toggleClass('sticky', is_sticky);
        if (is_sticky) {
            this.$sticky.parent().removeClass('unstuck');
            this.$sticky.parent().addClass('stuck');
        } else {
            this.$sticky.parent().removeClass('stuck');
            this.$sticky.parent().addClass('unstuck');
        }
    }

    loadStickyHeader = () => {
        this.$sticky = this.$element.find('.sticky-header-wrapper');
        if (this.$sticky.length === 0) {
            return;
        }

        var $menu_wrapper = this.$sticky.find('.sticky-header-menu');
        var $icon_wrapper = this.$sticky.find('.sticky-header-icons');
        // copy main menu
        $('#main-navigation-wrapper').clone().appendTo($menu_wrapper);

        // copy menu icons (cart, search, ...)
        $('.cart-link li a').each(function () {
            $('<div class="sticky-header-icon"></div>').append($(this).clone()).appendTo($icon_wrapper);
        });

        // copy search bar
        var $search = this.$sticky.find('.sticky-header-search')
        $('.top-search').clone().appendTo($search);

        // copy mobile menu
        var $mobile_menu = $('.mobile-header--wrapper').clone().appendTo(this.$sticky.find('.sticky-mobile-header'));
        $mobile_menu.find('.slide-menu-mobile').off('click').on('click', function () {
            $('#theme-menu').trigger('mobile:toggle');
        });

        window.addEventListener('scroll', this.updateStickyHeader);
        this.updateStickyHeader();

        // bind cart open to the cart icon
        this.$sticky.find('.slide-menu-cart').off('click').on('click', function (e) {
            $('#cartSlideoutWrapper').trigger('cart:toggle');
            // prevent non-ajax basket
            e.preventDefault();
            return false;
        });
    }

    loadDropdownHover = () => {
        this.dropdownTimeout = null;
        this.touchHoverTimeout = null;
        this.dropdownHandle();
    }

    openMenu = ($menu, $handler, force = false) => {
        if ($handler.is('.dropdown-envy-toggle')) {
            this.closeAllDropdowns();

            // Align submenu with bottom of the menu
            let offset = $menu[0].offsetHeight + $menu[0].offsetTop;
            $menu.find('> .dropdown-menu:not(dropdown-menu--mega)').css('margin-top', offset + 'px');

            // Align megamenu with bottom of the header
            var $el = $('.header-wrapper');
            if($('.sticky').length > 0) {
                $el = $('.sticky-header-wrapper');
            }

            // Place megamenus at the bottom of the header, rather than under their parent menu link.
            let megaOffset = $el.position().top + $el.outerHeight() - 1;

            if($el.is('.header-wrapper--overlay.unstuck') && $('.notification-bar').length) {
                megaOffset = megaOffset - $('.notification-bar').outerHeight();
            }

            // Replace offset with just megaOffset if you want to revert.
            $menu.find('> .dropdown-menu--mega').css('margin-top', offset + 'px');
        }

        $menu.addClass(force ? 'force-open' : 'open');
        this.selectMenuDirection($menu);
    }

    closeMenu = ($menu) => {
        $menu.removeClass('open');
    }

    getMenuFromHandler = ($handler) => {
        return $handler.is('.dropdown-envy-toggle') ? $handler.parent() : $handler;
    }

    dropdownHandle = () => {
        // open menu/submenu on mousehover
        var $dropdown_toggle = this.$element.find('.dropdown-envy-toggle,.dropdown-menu > li,.dropdown-menu--mega');
        $dropdown_toggle.off('mouseenter touchend').on('mouseenter touchend', (/** @type MouseEvent */ e) => {
            e.stopPropagation();
            const $handler = $(e.currentTarget);
            const $menu = this.getMenuFromHandler($handler);

            if (e.type ==='touchend') {
                if (this.touchHoverTimeout) {
                    clearTimeout(this.touchHoverTimeout);
                    this.touchHoverTimeout = null;
                }
                this.element.classList.add('touch-hover');
                if ($menu.is('.dropdown-submenu,.mega-menu--dropdown-wrapper') && !$menu.hasClass('open')) {
                    // Prevent click on link when dropdown menu is touched and not yet open
                    e.preventDefault();
                }
            }

            // Find neighbours and close them
            $menu.closest('.mega-menu--dropdown-wrapper').find('.open').not($menu.closest('.dropdown-submenu')).removeClass('open');

            // wait for some time before opening the menu
            if (this.dropdownTimeout) {
                clearTimeout(this.dropdownTimeout);
            }
            this.dropdownTimeout = setTimeout(this.openMenu, 10, $menu, $handler);
        });

        // handle closing menu when hover ends
        $dropdown_toggle.off('mouseleave').on('mouseleave', (e) => {
            const $handler = $(e.currentTarget);
            const $menu = this.getMenuFromHandler($handler);

            // Wait a bit then close
            if (this.dropdownTimeout) {
                clearTimeout(this.dropdownTimeout);
            }
            this.dropdownTimeout = setTimeout(this.closeMenu, 1500, $menu);
        });

        $('.nav-pills').off('mouseleave').on('mouseleave', this.navigatedFromMenu);

        // hide menu when touched anywhere else then the menu
        $('body').on('touchstart', this.navigatedFromMenu);
    }

    navigatedFromMenu = (e) => {
        if (this.touchHoverTimeout) {
            clearTimeout(this.touchHoverTimeout);
        }
        this.touchHoverTimeout = setTimeout(() => {
            this.touchHoverTimeout = null;
            this.element.classList.remove('touch-hover');
        }, 50);

        // // Close sticky menu dropdowns.
        // if($(e.target).parents('.sticky-header-menu').length > 0) {
        //     // Add listener to mouseleave on sticky header
        //     $(e.target).find('.dropdown-menu').off('mouseleave').on('mouseleave', this.closeAllDropdowns);
        //     return;
        // }

        // don't hide menu if we touched "inside" the menu
        if (e.type === 'mouseleave' || $(e.target).parents('.mega-menu--dropdown-wrapper.open,.dropdown-submenu.open').length === 0) {
            this.closeAllDropdowns();
        }
    }

    closeAllDropdowns = () => {
        $('.mega-menu--dropdown-wrapper.open,.dropdown-submenu.open').removeClass('open');
    }

    selectMenuDirection = ($menu) => {
        // Fix submenu opening outside of viewport by showing it to the left of menu
        var children_widths = $menu.find('.dropdown-menu .dropdown-menu').map(function () {
            var $this = $(this);
            var width = $this.css({'display': 'block', 'visibility': 'hidden'}).outerWidth();
            $this.css({'display': '', 'visibility': ''});
            return width;
        });
        var max_width = Math.max.apply(null, children_widths);
        var $submenu = $menu.find('> .dropdown-menu');
        if ($submenu.length === 0) {
            return;
        }
        var left = $submenu.offset().left;
        var right = left + $submenu.outerWidth() + max_width;
        var switch_to_left = right > $('body').width() && left - max_width > 0;
        $submenu.toggleClass('dropdown-submenu-left', switch_to_left);
    }

    fixHeaderHeight = () => {
        var announcementBar = $('#shopify-section-announcement-bar').height();
        var header = $('#shopify-section-header').height();
        var textAdverts = $('#shopify-section-text-adverts').height();
        var headerHeight = announcementBar + header + textAdverts;
        var nonOverlayHeight = announcementBar + textAdverts;

        // Only apply if the slideshow is set to full screen size.
        if($('.slideshow--full-screen').length) {
            // Don't apply the height if the header is overlaid on the slideshow.
            if($('.header-wrapper--overlay').length === 0) {
                $('.slideshow--full-screen').css('height', 'calc(100vh - ' + headerHeight + 'px)');
                $('.slideshow--full-screen ul.slides li').css('height', 'calc(100vh - ' + headerHeight + 'px)');
            }
            else {
                $('.slideshow--full-screen').css('height', 'calc(100vh - ' + nonOverlayHeight + 'px)');
                $('.slideshow--full-screen ul.slides li').css('height', 'calc(100vh - ' + nonOverlayHeight + 'px)');
            }
        }
    }
}
